import { type CompanyConfig, TimeFormat } from '../interface';

// DubaiExpress keeps its warehouse under different codes per backend: production
// serves it as "SG01", the stage backend (api2-stage) as "DUBAI".
const activeApiRoot = import.meta.env.SSR
  ? process.env.REACT_APP_API_ROOT
  : (
      window.__INITIAL_STATE__?.context?.variables as
        | { REACT_APP_API_ROOT?: string }
        | undefined
    )?.REACT_APP_API_ROOT;
const defaultWarehouseCode = activeApiRoot?.includes('api2-stage')
  ? 'DUBAI'
  : 'SG01';

export const DubaiExpressConfig: CompanyConfig = {
  id: '62a967ce-863f-48ad-b86b-f1c01eb33c86',
  lang: 'ru',
  langs: ['ru'],
  name: 'DubaiExpress',
  nameSecondary: 'DubaiExpress',
  currency: '₽',
  currencyCode: 'RUB',
  officialName: 'Dubai Express',
  email: 'care@dubaiexpress.com',
  feedbackEmail: 'care@dubaiexpress.com',
  marketingEmail: 'marketing@dubaiexpress.com',
  phonePlaceholder: '+7',
  defaultPhoneCode: '+7',
  ageRestricted: 0,
  timeZone: 'Europe/Moscow',
  minimalOrderFeeThreshold: 700,
  address: 'Москва, Россия',
  canonical: 'https://dubaiexpress.ru',
  defaultVolumeDisplay: '',
  showCookieBanner: true,
  contacts: {
    workingHours: {
      start: '9:00',
      end: '21:00',
      timezone: 'МСК',
    },
    officeAddress: [
      'DSO-IFZA, IFZA Properties,',
      'Dubai Silicon Oasis,',
      'United Arab Emirates',
    ],
  },
  defaultCity: 'Москва',
  warehouse: {
    default: defaultWarehouseCode,
    minimalOrderFeeWarehouseCodes: [],
    location: {
      lat: 55.7558,
      lng: 37.6173,
    },
  },
  map: {
    center: { lat: 55.7558, lng: 37.6173 },
    zoom: 11,
  },
  paymentMethods: [],
  availablePaymentMethods: [],
  timeFormat: TimeFormat.h24,
  links: {
    cookie: '',
    deliveryZones: '',
    forRiders: '',
    affiliateProgram: import.meta.env.REACT_APP_AFFILIATE_PROGRAM_LINK,
    deliveryTracking: 'https://gbs.ru/track/?numbers=',
    vk: 'https://vk.ru/dubaidutyfree',
    blog: '/blog',
    legals: {
      cookiePolicy: {
        label: 'cookiePolicy',
        link: '/legals#cookie-policy',
      },
      paymentAndDeliveryPolicy: {
        label: 'paymentAndDeliveryPolicy',
        link: '/legals#payment-and-delivery',
      },
      privacyPolicy: {
        label: 'privacyPolicy',
        link: '/legals#privacy-policy',
      },
      salesAndReturnPolicy: {
        label: 'salesAndReturnPolicy',
        link: '/legals#sales-and-returns-policies-and-consumer',
      },
      generalTradingPolicy: {
        label: 'generalTradingPolicy',
        link: '/legals#terms-of-service',
      },
    },
  },
  referral: {
    code: '',
    discount: '',
    minBasket: '',
    downloadAppLink: '',
  },
  appStoreUrl: {
    ios: 'https://apps.apple.com/...',
    android: 'https://play.google.com/...',
  },
  apis: {
    yaMetrika: {
      production: '106451003',
      test: '111603904',
      useEcommercePayload: true,
    },
  },
  countryCode: 'RU',
  license: {
    name: '',
    numberPrinary: '',
    numberSecondary: '',
  },
};
